<template>
  <div class="container-fluid">
    <!-- 본인 인증하기   -->
    <div class="row join-page" v-if="confirm === false">
      <div class="col-12 p-0" v-if="joinUrl === 'atl'">
        <!-- 240206 아틀란 이벤트 -->
        <img src="@/assets/event/20250519_ATL_V13.png" @click="showConfirm" alt="아틀란_이벤트_이미지" />
      </div>
      <div class="col-12 p-0" v-else >
        <img v-if="joinUrl === 'mancharo'" src="@/assets/main_mancharo.jpg">
        <img v-else-if="image_code === '102108'" src="@/assets/event/20250519_HMM_V1.png">
        <img v-else-if="image_code === '103108'" src="@/assets/event/20250519_MAN_V2.png">
        <img v-else src="@/assets/main_hmm.jpg">
      </div>
      <div class="mt-2 p-0">
        <div class="text-start mt-2" v-if="joinUrl !== 'atl'">
          <dt class="fs-title">본인인증 하기</dt>
          <dd class="fs-nav pb-2">{{ homeName }} 회원가입을 위해서는<br/>본인인증이 필요합니다<br/>본인인증 하기 버튼을 클릭하세요.</dd>
          <div class="d-flex flex-column align-items-center mt-2">
            <div class="verify-icon" @click="showConfirm"><img class="login-btn" src="../assets/sns/hmm_check_png.png" alt="본인인증 하기 버튼"/></div>
            <div class="mt-1 verify-icon" @click="loginWithKakao"><img class="login-btn" src="../assets/sns/kakao_check_png.png" alt="카카오 로그인 버튼"/></div>
          </div>
<!--          <div @click="doNaverLogin" class="naver-css d-flex justify-content-center"><img class="login-btn" src="../assets/sns/btnG_완성형.png" alt="네이버 로그인 버튼"/></div>-->
        </div>
        <div class="d-flex flex-column mt-2" v-else>
          <!-- 카카오 API -->
          <a id="kakao-login-btn" @click="loginWithKakao">
            <div class="mt-1 verify-icon" @click="loginWithKakao"><img class="login-btn" src="../assets/sns/kakao_check_png.png" alt="카카오 로그인 버튼"/></div>
          </a>
          <!-- 네이버 API -->
<!--          <div id="naver_id_login">-->
<!--            <a id="naver-login-btn" @click="doNaverLogin">-->
<!--              <div class="naver-css"><img src="../assets/sns/btnG_완성형.png" alt="네이버 로그인 버튼"/></div>-->
<!--            </a>-->
<!--          </div>-->
        </div>
      </div>
    </div>
    <!-- 본인인증 완료 -->
    <div v-if="confirm === true">
      <dl class="text-start">
          <dt class="fs-3">본인 인증이<br/>완료되었습니다 :)</dt>
          <dd >아래 정보를 확인해주세요.</dd>
      </dl>
      <div class="card">
          <div class="card-body text-start">
            <div class="row gap-1">
              <div class="row">
                <label for="inputEmail3" class="col-4 col-form-label" >이름</label>
                <div class="col-4 px-0">
                  <input type="text" class="form-control" id="inputEmail3" :value="userInfo.name" readonly>
                </div>
                <div class="col-4 px-0">
                  <input type="text" class="form-control" id="inputEmail4" :value="nationalName" readonly>
                </div>
              </div>
              <div class="row">
                <label for="inputPassword3" class="col-4 col-form-label">생년월일</label>
                <div class="col-4 px-0">
                  <input type="text" class="form-control" id="inputPassword3" :value="userInfo.birth" readonly>
                </div>
                <div class="col-4 px-0">
                  <div class="btn-group w-100" role="group" aria-label="Basic radio toggle button group">
                    <button class="btn gender-button" :class="userGender === '1' ? 'active' : 'non-active'">남</button>
                    <button class="btn gender-button" :class="userGender === '0' ? 'active' : 'non-active'">여</button>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
      <footer class="footer mt-3 d-flex gap-1 justify-content-end">
        <button class="btn btn-primary col-12 rounded-pill" @click="moveAfter">다음</button>
      </footer>
    </div>
  </div>
</template>

<script>
import config from '../_config.js';
/**
 * 간편회원가입 - 본인인증 페이지
 */

export default {
  name: "MobileValidationPoint",
  data(){
    return {
      currentPageData: {
        page : '',
      },
      userInfo : {
        birth : '850812',
        gender : '1',
        name : '홍길동',
        national : '1',
        mobile : '01012341234',
      },
      selectedGender : 0,
      nationalName : '',
      confirm:false,
      homeName:'',
      joinUrl:'',
      image_code: '',
      test_mode:false,
    }
  },
  computed: {
    userGender() {
      return this.selectedGender;
    },
  },
  mounted() {
    this.joinUrl = this.$store.getters.getJoinUrl;
    this.image_code = sessionStorage.getItem("now-code");
    console.log("image_code : ", this.image_code);
    this.test_mode = this.$store.getters.getTestEnv;
    this.homeName = this.joinUrl === 'mancharo' ? '만차로' : '화물맨';
  },
  methods:{
    async moveAfter(){

      if(!this.test_mode){
        //테스트 모드가 아닐 경우 실행
        const duplicateCheck = await this.$http.post('/api/user/reg/mmn', this.userInfo)
            .catch(err=> {
              this.$swal.fire('에러 : '+err.message);
            });

        if (duplicateCheck === undefined) {
          return ;
        }

        if(duplicateCheck.data.code != '200'){
          await this.$swal.fire('회원님은 서비스 \n이용이력이 있으신 회원이십니다.\n콜센터를 통해서 \n가입신청을 진행하십시오.');
          await this.$router.push({ path: '/' });
          return;
        }

      }

      //화물맨 기본 로직
      if(this.joinUrl === 'hmm' || this.joinUrl === 'mancharo'){
        this.currentPageData.page = 'hmm';
      } else if(this.joinUrl === 'atl'){
        this.currentPageData.page = 'atl';
      }

      this.$store.commit('setMemberInfo', this.userInfo);
      this.$emit('current-page',this.currentPageData);
    },
    showConfirm(){
      if(this.test_mode){
        //테스트용 성별 값
        this.confirm = true;
        this.selectedGender = '1';
        this.nationalName = '내국인';
        this.userInfo.mobile = this.generatedPhoneNumber();
        this.$store.commit('setMemberInfo',this.userInfo);
        return;
      }
      //본인인증
      window.addEventListener("message", this.receiveMessage, false);
      window.open('https://auth.bgsoft.kr:8443/nice_module/chk', '_blank',  'width=500,height=600' );
    },
    async receiveMessage(response){
      const name = response.data.name;
      const mobile = response.data.phone;
      const birth = response.data.birth;
      const national = response.data.national;
      const gender = response.data.gender;

      if(this.isEmpty(name) || this.isEmpty(mobile)){
        await this.$swal.fire('오류가 발생했습니다.');
        return;
      }

      this.userInfo.name = name;
      this.userInfo.mobile = mobile;
      this.userInfo.birth = birth;
      this.userInfo.national = national;
      this.userInfo.gender = this.changeGenderCode(national,gender,birth);

      this.selectedGender = gender;
      this.nationalName = this.getNationality(national);

      this.confirm = true;
      this.$store.commit('setMemberInfo',this.userInfo);

    },
    isEmpty(value) {
      return value === undefined || value === null || String(value).trim() === '';
    },
    changeGenderCode(national, gender, birth){
      if (national == "0") {  //내국인
        if (gender == "1") { //남성(1)
          if (birth[0] =="2"){  //2000년대생
            return "3";
          } else {
            return "1";
          }
        } else {              //여성(0)
          if (birth[0] == "2"){  //2000년대생
            return "4";
          } else {
            return "2";
          }
        }
      } else {  //외국인
        if (gender == "1") { //남성(1)
          if (birth[0] == "2"){  //2000년대생
            return "7";
          } else {
            return "5";
          }
        } else {              //여성(0)
          if (birth[0] == "2"){  //2000년대생
            return "8";
          } else {
            return "6";
          }
        }
      }
    },
    getNationality(national){
      return national == '0' ? '내국인' : '외국인';
    },
    generatedPhoneNumber(){
      let min = Math.pow(10, 10);
      let max = Math.pow(10, 11) - 1;
      // Math.random()을 사용하여 랜덤 숫자 생성 후 11자리로 만듭니다.
      let randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;

      return randomNumber.toString(); // 문자열로 반환
    },
    loginWithKakao() {
      window.Kakao.Auth.authorize({
        redirectUri: `${config.apiRoot}api/kakao/join/cal`,
        // redirectUri: `http://222.231.9.248:8080/api/kakao/${this.$store.getters.getJoinUrl}`,
      });
    },
    // loginWithNaver(){
    //   const client_id = 'coXCcfHCPlady8NZB1H7';
    //   const redirectUrl = 'http://192.168.0.213:9090/api/naver';
    //   const domain = "http://192.168.0.213:8080/";
    //   var naver_id_login = new window.naver_id_login(client_id, redirectUrl);
    //   var state = naver_id_login.getUniqState();
    //   naver_id_login.setButton("white", 2,40);
    //   naver_id_login.setDomain(domain);
    //   naver_id_login.setState(state);
    //   naver_id_login.setPopup();
    //   naver_id_login.init_naver_id_login();
    // },
    doNaverLogin() {
      const client_id = 'coXCcfHCPlady8NZB1H7';
      const redirectUrl = 'http://192.168.0.213:9090/api/naver/' + this.$store.getters.getJoinUrl;
      // const redirectUrl = 'http://192.168.0.213:8080/#/naver/redirect' + this.$store.getters.getJoinUrl;
      const state = encodeURI(redirectUrl);
      const url = 'https://nid.naver.com/oauth2.0/authorize?response_type=code&client_id=' +
          client_id +
          '&redirect_uri=' +
          redirectUrl +
          `&state=${state}`;
      //
      // this.showSocialLoginPopup(url)
      window.location.href = url;
    },
    showSocialLoginPopup(url) {
      const popupHeight = '500'
      const popupWidth = '500'
      let popupOptions = 'height=--popupHeight--,width=--popupWidth--,left=--popupX--,top=--popupY--,scrollbars=yes,resizable=yes'

      popupOptions = popupOptions.replace('--popupHeight--', popupHeight)
      popupOptions = popupOptions.replace('--popupWidth--', popupWidth)

      this.openPopup(url, popupOptions)
      return false
    },
    openPopup(url, options) {
      window.open(
          url,
          '_blank',
          options
      )
    },
  },
}
</script>

<style scoped>
/* 스타일 수정 */
.gender-button {
  color: #333;
  border: 1px solid #ccc;
  background-color: #f0f0f0;
  padding: 0.375rem 0.75rem;
  cursor: pointer;
}

.gender-button.active {
  background-color: #4fb1ec;
  border-color: #4fb1ec;
  color: #fff;
  pointer-events: none;
}

.gender-button.non-active {
  background-color: #ccc; /* 회색 배경색으로 변경 */
  color: #fff; /* 회색 텍스트색으로 변경 */
  pointer-events: none;
}
img {
  max-width: 100%;
}
.naver-css {
  background-color: #03c75a !important;
  border-radius: 12px
}
.kakao-css {
  background-color: #FEE500;
  border-radius: 12px
}
.login-btn {
  //width: 100%;
  //height: 65px;
}
.verify-icon {
  width: 100%;
  max-width: 600px;
  max-height: 65px;
  min-height: 50px;
}
.join-page {
  max-width: 320px;
  max-height: 750px;
  margin: auto;
}
</style>